export const couchdbIndexManager = {
  create
}

function create (query) {
  return [generateSortIndex(query), getQueryIndex(query)]
}

const multipleKeys = ['$ne', '$lt', '$lte', '$gt', '$gte', '$or', '$in']
let orientation = 'asc'
let fields = []

function generateSortIndex (query) {
  if (!query.hasOwnProperty('sort')) {
    return {fields: [], name: ''}
  }
  let fieldsName = []
  let fields = []
  let orientation = 'asc'
  for (let sort of query['sort']) {
    for (let field in sort) {
      fieldsName.push(field)
      if (sort[field] === 'desc') {
        orientation = 'desc'
        break
      }
    }

    for (let field in sort) {
      let obj = JSON.parse('{}')
      obj[field] = orientation
      fields.push(obj)
    }
  }
  return {
    fields,
    name: fieldsName.join('-') + '-' + orientation + '-index'
  }
}


/**
 * @param array $finder
 * @return array
 */
function getQueryIndex (finder) {
  if (!finder.hasOwnProperty('selector') || finder.selector.length === 0) return
  fields = []
  for (let index in finder['selector']) {
    if (multipleKeys.indexOf(index) === -1) {
      fields.push(index)
    }
  }

  if (finder.hasOwnProperty('sort')) {
    defineSortOrientation(finder.sort)
  }

  return {
    'fields': finder.hasOwnProperty('sort') ? defineFieldsOriented() : fields,
    'name': fields.join('-') + '-' + orientation + '-index'
  }
}

function defineFieldsOriented () {
  return fields.map(item => {
    const a = {}
    a[item] = orientation
    return a
  })
}

function defineSortOrientation (sort) {
  if (sort.length === 0) {
    return
  }
  for (let s of sort) {
    for (let field in s) {
      let orient = s[field]
      if (orient === 'desc') {
        orientation = 'desc'
      }
      if (!isNaN(field)) {
        updateIndexFieldsWithSortField(orient)
        continue
      }
      updateIndexFieldsWithSortField(field)
    }
  }
}

function updateIndexFieldsWithSortField (field) {
  if (fields.indexOf(field) === -1) fields.push(field)
}



// WEBPACK FOOTER //
// ./src/services/couchdb/couchdbIndexManager.js